// Centralized restaurant configuration
export const restaurantData = {
  name: "Shaker resto bar",
  logo: "https://images.unsplash.com/photo-1414235077428-338989a2e8c0?w=400&h=400&fit=crop",
  tagline: "whereTraditionMeets"
};

export const restaurantProfile = {
  name: "Bistro Gourmet",
  tagline: "Culinary Excellence Since 2020",
  cuisine: "Contemporary American",
  phone: "+1 (555) 123-4567",
  email: "info@gourmetkitchen.com",
  address: "123 Culinary Street, Food District, NY 10001",
  hours: "Mon-Sun: 11:00 AM - 10:00 PM",
  currency: "USD",
  logo: "https://img.rocket.new/generatedImages/rocket_gen_img_1160482f2-1767620631031.png",
  logoAlt: "Elegant restaurant logo featuring stylized chef hat and crossed utensils in gold on dark background"
};

export default restaurantData;